import { skipIfNull } from '@proscom/prostore';
import { useRetriableGraphqlVars } from '../../common/useRetriableGraphqlVars';
import {
  QUERY_CONTEST_DOCS_FOR_SS_MONITORING_PAGE,
  QUERY_CONTEST_DOCS_MONITORING_PAGE
} from '../../graphql/queries/contestDocsMonitoring';

const contestDocsMonitoringPageQueryOptions = {
  query: QUERY_CONTEST_DOCS_MONITORING_PAGE,
  mapData: (data) => data.monthlyMonitoringTenderDocumentationsPage,
  skipQuery: skipIfNull(null)
};

export function useContestDocsMonitoringPage(filter, paginationParams) {
  return useRetriableGraphqlVars({
    queryOptions: contestDocsMonitoringPageQueryOptions,
    variableCreator: [
      () =>
        filter
          ? {
              input: {
                filter: filter,
                pagination: paginationParams
              }
            }
          : null,
      [filter, paginationParams]
    ],
    options: {
      apolloOptions: {
        fetchPolicy: 'network-only'
      }
    }
  });
}
